module.exports = "pegasus/assets/preview-13.png";